import { render, staticRenderFns } from "./addforbidTheSale.vue?vue&type=template&id=f9882152&scoped=true&"
import script from "./addforbidTheSale.vue?vue&type=script&lang=js&"
export * from "./addforbidTheSale.vue?vue&type=script&lang=js&"
import style0 from "./addforbidTheSale.vue?vue&type=style&index=0&id=f9882152&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f9882152",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/manage.pc.frontend-purchase-test/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f9882152')) {
      api.createRecord('f9882152', component.options)
    } else {
      api.reload('f9882152', component.options)
    }
    module.hot.accept("./addforbidTheSale.vue?vue&type=template&id=f9882152&scoped=true&", function () {
      api.rerender('f9882152', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/general/forbidTheSale/modules/addforbidTheSale.vue"
export default component.exports